enum DealClosedDateSettingValue {
  CHANGE_TO_TODAY = "change-to-today",
  REMAIN_SAME = "remain-same",
  ASK_EVERYTIME = "ask-everytime",
}

export default DealClosedDateSettingValue;
